import { createContext } from 'react';
import { observable } from 'mobx';
import Layout from '../../../../../../@Api/Layout/Layout';

export const HighlightedLayoutContext = createContext(observable.box<Layout>());
